import { jsx as _jsx } from "react/jsx-runtime";
import { useEventReporter, useOverlayContext, useStoreActions } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import ZapierLegacyModal from './ZapierLegacyModal';
import ZapierLogo from './ZapierLogo';
export default function ZapierCard() {
    const { t: zapierTexts } = useLocaleKeys('integrations.availableApps.zapier');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { SHOW_ZAPIER_V2_API_KEY_GENERATION } = useFeatureFlags();
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('zapier');
    const { api, logBI } = useStoreActions();
    const { reportToAppcues, reportToGtm, reportToHeap, reportToHubspot } = useEventReporter();
    const overlayContext = useOverlayContext();
    const openLegacyModal = ()=>{
        logBI(12050);
        reportToAppcues('button-click', 'zapier-vendor-clicked-connect');
        reportToGtm('button-click', 'zapier-vendor-clicked-connect');
        reportToHeap('integrations', 'click', 'zapier-connect');
        reportToHubspot('vendor_clicked_connect_to_zapier');
        overlayContext.showModal({
            biName: 'zapier_integrate_modal',
            closeOnEscapeKey: true,
            closeOnClickOutside: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ZapierLegacyModal, {
                    dismissModal: dismissModal,
                    getApiKey: ()=>api.zapier.getApiKey(),
                    onCopyApiKey: ()=>{
                        logBI(12051);
                        reportToAppcues('button-click', 'zapier-vendor-copied-api-key-to-clipboard');
                        reportToGtm('button-click', 'zapier-vendor-copied-api-key-to-clipboard');
                        reportToHeap('integrations', 'click', 'zapier-copy-api-key');
                        reportToHubspot('vendor_copied_api_key_to_clipboard');
                    }
                });
            }
        });
    };
    const onConnectClick = SHOW_ZAPIER_V2_API_KEY_GENERATION ? showCopyAPIKeyModal : openLegacyModal;
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "zapier-card",
        icon: /*#__PURE__*/ _jsx(ZapierLogo, {}),
        title: zapierTexts.title(),
        subTitle: zapierTexts.subtitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_zapier'
            },
            onClick: onConnectClick,
            testId: "zapier-card-connect",
            children: sharedTexts.connectButton()
        })
    });
}
